<template>
    <div v-click-outside="close" class="relative z-50">
        <div @click="toggle" class="cursor-pointer">
            <slot name="trigger"></slot>
        </div>
        <transition name="slide-fade" :css="isTransitionEnabled" @after-leave="isTransitionEnabled = true">
            <div v-if="isOpen" class="toggle-menu absolute z-50 right-0" >
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const isOpen = ref(false);
const isTransitionEnabled = ref(true)

const toggle = () => {
    isOpen.value = !isOpen.value;
};

const close = (immediately = false) => {
    isTransitionEnabled.value = !immediately
    isOpen.value = false
};

defineExpose({ close })
</script>

<style scoped>
:global(.slide-fade-enter-active),
:global(.slide-fade-leave-active) {
    transition: max-height 0.5s ease, opacity 0.5s ease;
}

:global(.slide-fade-enter-from),
:global(.slide-fade-leave-to)

/* .slide-fade-leave-active in <2.1.8 */
    {
    max-height: 0;
    opacity: 0;
}

:global(.slide-fade-enter-to),
:global(.slide-fade-leave) {
    max-height: 1000px;
    /* Arbitrary large value for sliding effect */
    opacity: 1;
}

.toggle-menu {
    border: 1px solid rgb(255 255 255 / 0.58);
    background: rgb(255 255 255 / 0.72);
    box-shadow: 0 4px 12px oklch(0% 0 0 / 0.1);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
}
</style>
